module.exports = __webpack_public_path__ + "static/media/Success_Profile.db47c546.svg";